import { render, staticRenderFns } from "./issueDetail.vue?vue&type=template&id=7d8baa36&scoped=true"
import script from "./issueDetail.vue?vue&type=script&lang=js"
export * from "./issueDetail.vue?vue&type=script&lang=js"
import style0 from "./issueDetail.vue?vue&type=style&index=0&id=7d8baa36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8baa36",
  null
  
)

export default component.exports